import React, { useState, lazy, Suspense } from "react";
import PropTypes from "prop-types";
import _Button from "../../../generic/_Button";
import { useFormikContext, FieldArray } from "formik";
import _Input from "../../../generic/_Input";
import _Select from "../../../generic/_Select";
import _Badge from "../../../generic/_Badge";
import _Suggestions from "../../../generic/_Suggestions";
import ModalAction from "../../../modal/ModalAction";
import { Alert } from "react-bootstrap";
import Icon from "../../../Icon";
const Map = lazy(() => import("./ubication/Map"));

const MsgButtons = (props) => {
  const { carrousel = null } = props;
  const { values, errors, setFieldValue } = useFormikContext();
  const [show, setShow] = useState(false);

  const getBasePath = () => {
    return carrousel !== null
      ? `carrousel.${carrousel}.buttonActions`
      : "buttonActions";
  };

  const getCurrentValues = () => {
    return carrousel !== null
      ? values.carrousel?.[carrousel]?.buttonActions || []
      : values.buttonActions || [];
  };

  const getErrors = () => {
    return carrousel !== null
      ? errors?.carrousel?.[carrousel]?.buttonActions
      : errors?.buttonActions;
  };

  const getFieldError = (index, fieldName) => {
    const currentErrors = getErrors();
    if (
      currentErrors &&
      currentErrors[index] &&
      currentErrors[index][fieldName]
    ) {
      return currentErrors[index][fieldName];
    }
    return null;
  };

  const getGeneralError = () => {
    if (carrousel !== null) {
      return errors?.carrousel?.[carrousel]?.buttonActions;
    }
    return errors?.buttonActions;
  };

  const getFieldIsError = (index, fieldName) =>
    !!getFieldError(index, fieldName);

  const basePath = getBasePath();
  const currentValues = getCurrentValues();

  const getInitialActionByType = (type) => {
    switch (type) {
      case "openUrlAction":
        return { type, text: "", action: "", postback: "" };
      case "dialAction":
        return { type, text: "", action: "", postback: "" };
      case "createCalendarEventAction":
        return {
          type,
          title: "",
          description: "",
          startTime: "",
          endTime: "",
          action: "",
          postback: "",
        };
      case "ViewLocationAction":
        return {
          type,
          text: "",
          lat: "",
          long: "",
          label: "",
          action: "",
          postback: "",
        };
      case "ShareLocationAction":
        return {
          type,
          text: "",
          postback: "",
        };
      case "openUrlActionShortLink":
        return { type, text: "", action: "", postback: "" };
      default:
        return { type: "" };
    }
  };

  const renderInput = (item, index) => {
    switch (item.type) {
      case "openUrlAction":
        return (
          <>
            <_Input
              title="Dirección URL"
              type="text"
              name={`${basePath}.${index}.action`}
              value={item?.action || ""}
              placeholder="https://..."
              onChange={(e) =>
                setFieldValue(`${basePath}.${index}.action`, e.target.value)
              }
              errors={getFieldError(index, "action")}
              isError={getFieldIsError(index, "action")}
            />
          </>
        );

      case "dialAction":
        return (
          <>
            <_Input
              title="Número telefónico"
              type="tel"
              name={`${basePath}.${index}.action`}
              value={item?.action || ""}
              placeholder="Número de teléfono"
              onChange={(e) =>
                setFieldValue(`${basePath}.${index}.action`, e.target.value)
              }
              errors={getFieldError(index, "action")}
              isError={getFieldIsError(index, "action")}
            />
          </>
        );

      case "createCalendarEventAction":
        return (
          <>
            <_Input
              title="Título del Evento"
              type="text"
              name={`${basePath}.${index}.title`}
              value={item?.title || ""}
              placeholder="Ejemplo: Cumpleaños"
              onChange={(e) =>
                setFieldValue(`${basePath}.${index}.title`, e.target.value)
              }
              errors={getFieldError(index, "title")}
              isError={getFieldIsError(index, "title")}
            />
            <_Input
              title="Descripción"
              type="text"
              name={`${basePath}.${index}.description`}
              value={item?.description || ""}
              placeholder="Descripción del evento"
              onChange={(e) =>
                setFieldValue(
                  `${basePath}.${index}.description`,
                  e.target.value,
                )
              }
              errors={getFieldError(index, "description")}
              isError={getFieldIsError(index, "description")}
            />
            <_Input
              title="Inicio del Evento"
              type="datetime-local"
              name={`${basePath}.${index}.startTime`}
              value={item?.startTime || ""}
              onChange={(e) =>
                setFieldValue(`${basePath}.${index}.startTime`, e.target.value)
              }
              errors={getFieldError(index, "startTime")}
              isError={getFieldIsError(index, "startTime")}
            />
            <_Input
              title="Fin del Evento"
              type="datetime-local"
              name={`${basePath}.${index}.endTime`}
              value={item?.endTime || ""}
              onChange={(e) =>
                setFieldValue(`${basePath}.${index}.endTime`, e.target.value)
              }
              errors={getFieldError(index, "endTime")}
              isError={getFieldIsError(index, "endTime")}
            />
          </>
        );

      case "ViewLocationAction":
        return (
          <>
            <_Input
              title="Descripción"
              type="text"
              name={`${basePath}.${index}.description`}
              value={item?.description || ""}
              onChange={(e) =>
                setFieldValue(
                  `${basePath}.${index}.description`,
                  e.target.value,
                )
              }
              errors={getFieldError(index, "description")}
              isError={getFieldIsError(index, "description")}
            />
            <_Input
              title="Latitud"
              type="number"
              name={`${basePath}.${index}.lat`}
              value={item?.lat || ""}
              onChange={(e) =>
                setFieldValue(`${basePath}.${index}.lat`, e.target.value)
              }
              errors={getFieldError(index, "lat")}
              isError={getFieldIsError(index, "lat")}
            />
            <_Input
              title="Longitud"
              type="number"
              name={`${basePath}.${index}.long`}
              value={item?.long || ""}
              onChange={(e) =>
                setFieldValue(`${basePath}.${index}.long`, e.target.value)
              }
              errors={getFieldError(index, "long")}
              isError={getFieldIsError(index, "long")}
            />
            <Suspense
              fallback={<div className="p-5 text-center">Cargando…</div>}
            >
              <Alert variant="secondary" className="Notice">
                <Icon icon="add_location_alt" className={"text-gray-900"} />{" "}
                Selecciona la ubicación en el mapa
              </Alert>
              <Map
                selectable={true}
                latitude={item?.lat || 20.967}
                longitude={item?.long || -89.62318}
                onLocationSelect={({ latitude, longitude }) => {
                  setFieldValue(`${basePath}.${index}.lat`, Number(latitude));
                  setFieldValue(`${basePath}.${index}.long`, Number(longitude));
                }}
              />
            </Suspense>
          </>
        );

      case "openUrlActionShortLink":
        return (
          <>
            <_Suggestions
              title="Dirección URL"
              placeholder="https://..."
              handleChange={(value) => {
                setFieldValue("fallback", value);
                setFieldValue("template_fallback", value);
                setFieldValue(`${basePath}.${index}.action`, value);
              }}
              options={
                values?.listShortLinks?.map((item) => ({
                  value: item.shortlinks,
                  label: item.displayname,
                })) || []
              }
              errors={getFieldError(index, "action")}
              isError={getFieldIsError(index, "action")}
            />
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <_Badge count={currentValues.length}>
        <_Button
          icon="add"
          style="none"
          className="w-full"
          title="Acciones"
          onClick={() => setShow(true)}
        />
      </_Badge>

      <ModalAction
        onClose={() => setShow(false)}
        visible={show}
        title="Agregar Botones de Acción"
      >
        <div className="flex-grow-1 p-3" style={{ overflowY: "auto" }}>
          <FieldArray name={basePath}>
            {({ remove }) => (
              <div className="space-y-2 min-h-[200px] overflow-y-auto">
                {currentValues.map((item, index) => (
                  <div
                    key={index}
                    className="border px-4 py-2 rounded-md bg-gray-50 mb-2"
                  >
                    <_Select
                      name={`${basePath}.${index}.type`}
                      options={[
                        { value: "openUrlAction", label: "Url" },
                        {
                          value: "openUrlActionShortLink",
                          label: "Url Cortas",
                        },
                        {
                          value: "createCalendarEventAction",
                          label: "Calendario",
                        },
                        { value: "ViewLocationAction", label: "Ubicación" },
                        {
                          value: "ShareLocationAction",
                          label: "Compartir Ubicación",
                        },
                        { value: "dialAction", label: "Llamada" },
                      ]}
                      title="Tipo de acción"
                      value={item.type}
                      onChange={(e) => {
                        const newType = e.target.value;
                        setFieldValue(
                          `${basePath}.${index}`,
                          getInitialActionByType(newType),
                        );
                      }}
                      errors={getFieldError(index, "type")}
                      isError={getFieldIsError(index, "type")}
                    />

                    <_Input
                      title="Texto"
                      type="text"
                      name={`${basePath}.${index}.text`}
                      value={item?.text || ""}
                      onChange={(e) =>
                        setFieldValue(
                          `${basePath}.${index}.text`,
                          e.target.value,
                        )
                      }
                      errors={getFieldError(index, "text")}
                      isError={getFieldIsError(index, "text")}
                    />

                    {renderInput(item, index)}

                    <div className="flex justify-end">
                      <_Button
                        icon="close"
                        style="none"
                        onClick={() => remove(index)}
                        title="Eliminar"
                        type="button"
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </FieldArray>
        </div>

        <div className="p-3 bg-white">
          <div className="flex justify-end">
            {typeof getGeneralError() === "string" && (
              <p className="text-red-700 text-sm">{getGeneralError()}</p>
            )}
          </div>
          <div className="mt-3 flex justify-end gap-2 pt-3">
            <_Button
              title="Añadir Botón"
              icon="add"
              style="none"
              type="button"
              disabled={!!getGeneralError()}
              onClick={() => {
                const newValues = [
                  ...currentValues,
                  getInitialActionByType("openUrlAction"),
                ];
                setFieldValue(basePath, newValues);
              }}
            />
            <_Button
              style="primary"
              title="Listo"
              icon="check"
              disabled={!!getGeneralError()}
              onClick={() => setShow(false)}
            />
          </div>
        </div>
      </ModalAction>
    </>
  );
};

MsgButtons.propTypes = {
  carrousel: PropTypes.any,
};

export default MsgButtons;
